import React from "react";
import PropTypes from "prop-types";
import { Subscribe } from "unstated";
import SrpContainer from "../containers/SrpContainer";
import classes from "./styles.module.scss";

const options = {
  relevance: "Relevance",
  price: "Price",
  distance: "Distance",
  age: "Newest",
};

const Sort = ({ selected, changeSort }) => (
  <div className={classes.Sort}>
    <span>Sort by: </span>
    <label htmlFor="sort" className="ux-select js-sort">
      <select
        id="sort"
        value={selected}
        onChange={({ target: { value } }) => changeSort(value)}
      >
        {Object.entries(options).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </label>
  </div>
);

Sort.propTypes = {
  selected: PropTypes.string,
  changeSort: PropTypes.func.isRequired,
};

const SortContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { query }, changeSort }) => (
      <Sort selected={(query || {}).sort} changeSort={changeSort} />
    )}
  </Subscribe>
);

export default SortContainer;
